import React, { useState } from 'react';
import { i18n } from '../../translate/i18n';
import {
  Typography, IconButton, InputBase, CircularProgress, Button, Menu, MenuItem,
  Box,
  FormHelperText, Tooltip
} from '@mui/material';
import { Launch, AddCircleOutline, ArrowDropDown, ArrowBack, Search, RemoveCircleOutline, AddCircleOutlineRounded, Delete, Build, Print } from '@mui/icons-material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ExportIcon from '@mui/icons-material/LaunchOutlined';
import FileButtonDownload from '../../components/FileDownloadButton/FileDownloadButton';
import iconQrCode from '../../assets/qrcode.jpg';
import Helmet from '../../assets/helmet.png';
import { useSelector } from 'react-redux';

export default function TableTitle(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const superadmin = useSelector(state => state.auth.superadmin);
  const isAdmin = useSelector(state => state.auth.selectedAccess.role) === 'admin';

  return (
    <div style={styles.container}>
      <div style={styles.titleRow}>
        <div style={styles.titleContainer}>
          {props.clickBack && <IconButton onClick={props.clickBack} style={styles.arrowBack} size="large"><ArrowBack /></IconButton>}
          <Typography variant='h6' style={styles.title}>{props.title}</Typography>
        </div>
				<div style={styles.buttonsContainer}>
          {props.zipServiceReport &&
            <FileButtonDownload type="zipServiceReport" disabled={props.zipServiceReportDisabled} />}

					{props.clickExport &&
						<Button
							variant='outlined'
							aria-label="add"
							style={styles.button}
							onClick={props.clickExport}
							disabled={props.exportButtonDisabled || props.downloading}
							startIcon={props.downloading ? <CircularProgress size={14} style={{ color: 'green' }} /> : <Launch style={styles.icon} />}
						>
							{i18n.t('btnTableTileMatOverrides.export')}
						</Button>}

					{(props.addRow && !props.hideAddButton) &&
						<Button
							style={styles.button}
							variant='outlined'
							aria-label="add"
							onClick={props.addRow}
							startIcon={<AddCircleOutline />}
						>
							{props.addRowLabel ? props.addRowLabel : i18n.t('btnTableTileMatOverrides.addRowLabel')}
						</Button>}


          {(props.addFromExcel && superadmin) &&
            <Button
              style={styles.actionButton}
							variant='outlined'
							aria-label="add"
							onClick={props.addFromExcel}
							startIcon={<CloudUploadIcon />}
						>
							{props.addFromExcelLabel ? props.addFromExcelLabel : i18n.t('btnTableTileMatOverrides.import')}
						</Button>
          }
          {(props.showDownloadExcelModelButton && superadmin) &&
            <Button
              style={styles.actionButton}
							variant='outlined'
							aria-label="add"
							onClick={props.downloadExcelModel}
							startIcon={<CloudDownloadIcon />}
						>
							{props.downloadExcelModelLabel ? props.downloadExcelModelLabel : i18n.t('btnTableTileMatOverrides.import')}
						</Button>
          }
          {(props.showDownloadExcelButton && superadmin) &&
            <Button
              style={styles.actionButton}
							variant='outlined'
							aria-label="add"
							onClick={props.downloadExcel}
							startIcon={<CloudDownloadIcon />}
						>
							{props.downloadExcelLabel ? props.downloadExcelLabel : i18n.t('btnTableTileMatOverrides.import')}
						</Button>
          }
          {(props.showImportButton && superadmin) &&
            <Button
              style={styles.actionButton}
              variant='outlined'
              onClick={() => props.clickImportButton()}
              disabled={props.importButtonDisabled || props.downloading}
              title='Importar Dados'
              startIcon={props.downloading ? <CircularProgress size={24} /> : <ExportIcon />}
            >
             {props.importButtonLabel ? props.importButtonLabel : i18n.t('btnTableTileMatOverrides.importData')}
            </Button>
          }

					{props.showOptionsButton && (
            (props.inactivate || props.printQRCodes) &&
              <Button
                aria-controls='menuOptions'
                style={styles.optionsButton}
                variant='outlined'
                endIcon={<ArrowDropDown />}
                onClick={event => setAnchorEl(event.currentTarget)}
              >
                {i18n.t('btnTableTileMatOverrides.options')}
                {props.selectedItemsCount > 0 && <p>{`(${props.selectedItemsCount})`}</p>}
              </Button>
						)}

					<Menu
						id="menuOptions"
						anchorEl={anchorEl}
						keepMounted
						open={Boolean(anchorEl)}
						onClose={() => setAnchorEl(null)}
						style={styles.menuContainer}
					>
						{props.inactivate &&
              <MenuItem disabled={props.disableSendForInactivate} onClick={() => { setAnchorEl(null); props.inactivate(); props.sendForInactivate(); }}>
                <RemoveCircleOutline fontSize="small" color='inherit' />
                <div style={styles.optionsLabel}>{i18n.t('divTableTitleMat.option1')}</div>
              </MenuItem>}
            {props.inactivate &&
              <MenuItem disabled={props.disableSendForReactivate} onClick={() => { setAnchorEl(null); props.inactivate(); props.sendForReactivate(); }}>
                <AddCircleOutlineRounded fontSize="small" color='inherit' />
                <div style={styles.optionsLabel}>{i18n.t('divTableTitleMat.option5')}</div>
              </MenuItem>}
						{props.printQRCodes &&
              <Tooltip title={props.blockPrintQRCodesForAnalystAndContractor ? i18n.t('divTableTitleMat.tooltipBlockQRCode') : ''} arrow>
                <span>
                  <MenuItem disabled={props.disablePrintQRCodes || props.blockPrintQRCodesForAnalystAndContractor} onClick={() => { setAnchorEl(null); props.printQRCodes(); }}>
                    <img src={iconQrCode} style={styles.iconQrCode} alt="QRCODE" />
                    <div style={styles.optionsLabel}>{i18n.t('divTableTitleMat.option2')}</div>
                  </MenuItem>
                </span>
              </Tooltip>}

            {props.maintenanceEquipments &&
              <MenuItem disabled={props.disableSendForMaintenanceButton} onClick={() => { setAnchorEl(null); props.maintenanceEquipments(); props.sendForMaintenance(); }}>
                <img src={Helmet} style={styles.iconQrCode} alt="SENDFORMAINTENANCE" />
                <div style={styles.optionsLabel}>{i18n.t('divTableTitleMat.option3')}</div>
              </MenuItem>}
            {props.maintenanceEquipments &&
            <MenuItem disabled={props.disableReturnFromMaintenanceButton} onClick={() => { setAnchorEl(null); props.maintenanceEquipments(); props.returnFromMaintenance(); }}>
              <img src={Helmet} style={styles.iconQrCode} alt="RETURNFROMMAINTENANCE" />
              <div style={styles.optionsLabel}>{i18n.t('divTableTitleMat.option4')}</div>
            </MenuItem>}

            {props.deleteMultipleEquipments && superadmin &&
            <MenuItem disabled={props.disableDeleteMultipleEquipments} onClick={() => { setAnchorEl(null); props.deleteMultipleEquipments(); }}>
              <Delete fontSize="small" color='inherit' />
              <div style={styles.optionsLabel}>{i18n.t('divTableTitleMat.option6')}</div>
            </MenuItem>}
              
            <MenuItem disabled={props.disableMakeServiceInMass} onClick={() => { setAnchorEl(null); props.openModalMassService() }}>
              <Build fontSize="small" color='inherit' />
              <div style={styles.optionsLabel}>{i18n.t('divTableTitleMat.option7')}</div>
            </MenuItem>
            { (superadmin || isAdmin) &&
              <MenuItem disabled={!(superadmin || isAdmin) || props.disableMassServicesWithAttachmentsExport} onClick={() => { setAnchorEl(null); props.massServicesWithAttachmentsExport() }}>
                <Print fontSize="small" color='inherit' />
                <div style={styles.optionsLabel}>{i18n.t('divTableTitleMat.option8')}</div>
              </MenuItem>
            }
					</Menu>

				</div>
      </div>
      {!props.hideSearchInput && <div style={styles.searchRow}>
        <Search style={styles.searchIcon} />
        <InputBase
          style={styles.search}
          placeholder={props.placeholder}
          inputRef={props.inputRef}
          value={props.value}
          onChange={props.onChange}
        />
      </div>}
      {props.helperTextSearch && <FormHelperText>{props.helperTextSearch}</FormHelperText>}
    </div>
  );
}

const styles = {
  container: {
    padding: '10px 20px',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleContainer: {
    display: 'flex', alignItems: 'center'
  },
  title: {
    marginRight: 10,
  },
  row: {
    margin: '24px 0',
  },
  searchRow: {
    marginTop: '10px',
    maxWidth: '800px',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #ccc',
    padding: '2px 4px',
    borderRadius: '5px',
  },
  searchIcon: {
    color: '#ccc'
  },
  search: {
    flex: 1,
    marginLeft: '8px',
  },
  arrowBack: {
    marginRight: 10,
	},
	buttonsContainer: {
		display: 'flex',
		alignItems: 'center',
		margin: '0.25rem 0'
	},
	button: {
		marginLeft: '0.5rem',
	},
	optionsButton: {
		marginLeft: '0.5rem',
    maxHeight: '2.3rem',
    minWidth: '9.5rem',
	},
	menuContainer: {
		marginTop: '2.75rem'
	},
	optionsLabel: {
		display: 'flex',
		fontSize: '0.9rem',
		marginLeft: '0.5rem',
		alignItems: 'center',
	},
  iconQrCode: {
    width: '1rem',
    margin: '0 .15rem'
  },
  actionButton: {
    marginLeft: 10,
  }
};
